import { FilterState } from "@/components/FilterSidebar/FilterState";
import { FilterGroup } from "@/components/FilterSidebar/types";

export const riseFiltersActive = (
  filterState: FilterState | undefined,
  filterGroups: FilterGroup[],
) => {
  if (!filterState) return false;
  const activeFilters = filterState.removeEmptyFields(filterState.data);
  const activeFilterNames = Object.keys(activeFilters);

  const riseFilterNames: string[] = filterGroups
    .map((group) => group.filters)
    .flat()
    .filter((filter) => filter.filterDisplayType === "RISE")
    .map((filter) => filter.name);

  const riseActive = activeFilterNames.filter((value) =>
    riseFilterNames.includes(value),
  );

  return riseActive.length > 0;
};
